import { AnalyticsEvent } from '../../core/AnalyticsEvent'
import { SearchBarViewEventSchema } from '../../schemas/searchBar/SearchBarViewEventSchema'
import { getConfigFor } from '../../../../utils/configService'
import { SPLIT_FEATURES } from '../../../../utils/constants/feature'
import { CommonEventParams, getCommonParams } from '../../utils/CommonParams'

const GROCERY = 'grocery'

export interface UserViewSearchBarEventParams extends CommonEventParams {
  BUSINESS_VERTICAL: string
  EVENT_CATEGORY: string
  SEARCH_SUGGESTED_CAMPAIGN_NAME: string
}

export class SearchBarViewEvent extends AnalyticsEvent {
  constructor(params: UserViewSearchBarEventParams) {
    super(SearchBarViewEventSchema(), ['segment'])
    this.createEventObject(params)
  }
}

export async function trackSearchBarViewEvent(
  searchBarViewParams: UserViewSearchBarEventParams
): Promise<void> {
  searchBarViewParams.BUSINESS_VERTICAL = searchBarViewParams.EVENT_CATEGORY =
    GROCERY
  const config = getConfigFor(SPLIT_FEATURES.LEAP_CDP_RELEASE_TWO) || {}
  const { isEnabled = false } = config
  if (isEnabled) {
    const params: UserViewSearchBarEventParams = {
      ...getCommonParams(),
      ...searchBarViewParams,
    }
    new SearchBarViewEvent(params).track()
  }
}
